import { Component, OnInit } from '@angular/core';
import { Electricity } from './electricity';
import { AppService } from '../app.service';
import { FormControl, Validators } from '@angular/forms';

declare var $;

@Component({
  selector: 'app-electricity',
  templateUrl: './electricity.component.html',
  styleUrls: ['./electricity.component.css']
})
export class ElectricityComponent implements OnInit {

  constructor(private service:AppService) { }

  customer_mobile=new FormControl('',[Validators.required,Validators.pattern(/^[6-9]\d{9}$/)]);

  ngOnInit() {
  }

  loader:boolean=false;
  electricity=new Electricity();
  errorMsg:string;
  successMsg:string;

  bill_no="";
  customer_name="";
  bill_due_date="";
  bill_amount="";
  
  numberOnly(event, length = 0): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else if (length > 0) {
      var valueLength = (event.target.value).length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }

  fetchBil(){

    var chkLogin=this.service.isLoggedIn();

    if(chkLogin){

    this.loader=true;
      this.service.post('/billFetch',{consumer_no:this.electricity.account_number,operator_code:"JAVVN"}).subscribe(
        data=>{
            if(data[0].error=='0'){
                this. successMsg=data[0].msg;
                this.bill_no=data[0].bill_no;
                this.customer_name=data[0].consumer_name;
                this.bill_due_date=data[0].bil_due_date;
                this.bill_amount=data[0].bil_amount;
                $('#myModal').modal('toggle'); 
            }else{
              // this.errorMsg=data[0].msg;
              alert(data[0].msg); 
            }

            this.loader=false;
        },
        error=>{
            // this.errorMsg=error.errorDesc;
            alert(error.errorDesc);
            this.loader=false;
        }
      );
    }else{
      alert("Please first login.");
    }
  }

  payBillLoader:boolean=false;
  payBill(){

    var chkLogin=this.service.isLoggedIn();

    if(!chkLogin){
      alert('Please first login');
    }else if(this.customer_mobile.invalid){
      alert('Please enter valid customer mobile no.');
      this.customer_mobile.reset();
    }else{
      this.payBillLoader=true;
      this.service.post('/payBill',{key:this.service.getAuthorizationToken(),consumer_no:this.electricity.account_number,customer_name:this.customer_name,bill_number:this.bill_no,bill_due_date:this.bill_due_date,bill_amount:this.bill_amount,"customer_mobile":this.customer_mobile.value})
        .subscribe(
          data=>{
            if(data[0].error=='0'){
              this.electricity=new Electricity();
              this.customer_mobile.reset();
              $('#myModal').modal('toggle');
            } 
            alert(data[0].msg);
            this.payBillLoader=false;
          },
          error=>{
              alert(error.errorDesc);
              this.payBillLoader=false;
          }
        )
    }
  }
}
